/** M4A1, as a thing you can carry. The gun itself is `sim/weapons/guns/m4a1.ts`. */

import { NO_ARMOR } from '@/sim/combat/armorMitigation';
import type { WeaponItem } from '@/sim/items/itemContract';

export const M4A1_ITEM = {
  id: 'm4a1',
  kind: 'weapon',
  label: 'M4A1',
  description:
    'The carbine every surviving armoury has a crate of. Nothing about it is special, on purpose.',
  rarity: 'uncommon',
  weightKg: 3.0,
  stackLimit: 1,
  equip: {
    slots: ['primaryWeapon'],
    statDeltas: {},
    armor: NO_ARMOR,
    damageModifiers: [],
  },
  weaponId: 'm4a1',
} as const satisfies WeaponItem;
